import { render } from "./HomeView.vue?vue&type=template&id=44a3b74b&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=44a3b74b&lang=scss&scoped=true"

import exportComponent from "D:\\www\\gt_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a3b74b"]])

export default __exports__